import React, { useState } from 'react';
import ArrayBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/ArrayBuilder';
import { Icon, SelectMenu, Typography } from '@scale/scaleui';
import { AgreementThresholdTypeSchemaMap } from '@scale/shared/pipelinev3/genai';
import { AgreementThreshold, AgreementRoutingTypeOverrideType } from '@scale/shared-types';
import type { TypeBuilderMapType } from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderSchemasType';

interface BelowAgreementThresholdsBuilderProps {
  name: string;
  existingValue?: Array<AgreementThreshold>;
  updateProperty: (arg: Array<AgreementThreshold> | undefined) => void;
  required?: boolean;
  typeBuilderMap: TypeBuilderMapType;
}

const stepTypeOptions = [
  {
    id: AgreementRoutingTypeOverrideType.ModelResponseSelector,
    name: 'Model Response Selector Step Type',
  },
  {
    id: AgreementRoutingTypeOverrideType.TextCollection,
    name: 'Text Collection Step Type',
  },
  {
    id: AgreementRoutingTypeOverrideType.TextCollectionPerResponse,
    name: 'Text Collection Per Response Step Type',
  },
  {
    id: AgreementRoutingTypeOverrideType.QualityMeasurement,
    name: 'Quality Measurement Step Type',
  },
];

const BelowAgreementThresholdsBuilder: React.FC<BelowAgreementThresholdsBuilderProps> = ({
  name,
  existingValue = [],
  updateProperty,
  typeBuilderMap,
}) => {
  const thresholds = existingValue;
  const [selectedStepType, setSelectedStepType] = useState<AgreementRoutingTypeOverrideType>(
    AgreementRoutingTypeOverrideType.ModelResponseSelector,
  );

  const addThreshold = (stepType: AgreementRoutingTypeOverrideType) => {
    const newThresholds = [...thresholds];
    newThresholds.push({
      stepType,
      stepId: '',
      ...(stepType === AgreementRoutingTypeOverrideType.TextCollectionPerResponse && {
        endpointId: '',
      }),
      ...((stepType === AgreementRoutingTypeOverrideType.TextCollection ||
        stepType === AgreementRoutingTypeOverrideType.TextCollectionPerResponse) && {
        fieldId: '',
      }),
      threshold: 0,
    } as any);
    updateProperty(newThresholds);
  };

  return (
    <div className="scaleui scaleui-tailwind scale-theme">
      {name && <div className="my-2 text-sm font-medium leading-6 text-neutral-700">{name}</div>}
      <ArrayBuilder
        typeBuilderMap={typeBuilderMap}
        elements={thresholds}
        setElements={updateProperty}
        getKey={threshold => JSON.stringify(threshold)}
        getTitle={threshold => `${threshold.stepType}`}
        getSchema={threshold => AgreementThresholdTypeSchemaMap[threshold.stepType]}
        delimiter={<Typography.Subtitle4>AND</Typography.Subtitle4>}
      />
      <div className="flex">
        <SelectMenu
          className="min-w-[135px]"
          options={stepTypeOptions}
          selectedOptionId={selectedStepType}
          setSelected={value => {
            setSelectedStepType(value as AgreementRoutingTypeOverrideType);
          }}
        />
        <Icon
          className="ml-4"
          hasBackground
          icon={['fas', 'plus']}
          onClick={() => addThreshold(selectedStepType)}
          size="lg"
          variant="primary"
        />
      </div>
    </div>
  );
};

export default BelowAgreementThresholdsBuilder;
